export const subscribe_zh = {
    subscribe: {
        dayReport: "今日报告数量",
        greatReport: "重大消息报告数量",
        customizeMessage: "自定义消息数量",
        unauditedReport: "未审核报告数量",
        reviewedReport: "已审核报告数量",
        chart: "每日历史图表",
        ReportRelease: "报告发布",
        beReviewedRelease: "待审核报告",
        number: "编号",
        date: "日期",
        ReportType: "报告类型",
        state: "状态",
        publisher: "发布人",
        auditor: "审核人",
        Subscriber: "订阅者组",
        MessageTitle: "消息标题",
        operation: "操作",
        audit: "审核",
        rejectedRelease: "已拒绝报告",
        correction: "订正",
        publishedRelease: "已发布报告历史",
        details: "详情",
        customizeHistory: "自定义消息历史",
        subscriber1: "订阅者",
        subscriber1Email: "订阅邮箱",
        subscriber1Type: "订阅类型",
        subscribe2: "订阅",
        DailySubscription: "日报订阅",
        WeeklySubscription: "周报订阅",
        MajorSubscription: "重大消息订阅",
        ConfirmSubscription: "确认订阅",
        SubscriptionHistory: "订阅操作历史",
        user: "用户",
        OperationContent: "操作内容",
        MessageHistory: "消息历史",
        receiveEmail: "接收邮箱",
        MessageDetails: "消息详情",
        customizeSubscription: "自定义订阅",
        customizeIndex: "自定义订阅指标",
        IndexName: "指标名",
        CurrentValue: "当前值",
        ConditionalSelection: "条件选择（涨跌幅或门限值）",
        increase: "涨幅百分比",
        increaseValue: "涨幅值",
        decline: "跌幅百分比",
        declineValue: "跌幅值",
        SMA: "SMA选择",
        alarm: "告警周期选择",
        unreadMessage: "未读消息详情",
        time: "时间",
        MessageContent: "消息内容",
        Please: "请输入",
        selectAlarm: "选择告警指标",
        subscriptionReport: "订阅观察报告",
        monthlyReport: "月报订阅",
        Unsubscribed: "退订",
        indicatorSelection: "指标选择",
        alarmType: "告警类型",        
        addressFilling: "地址填写",
        addressPrompt: "指定地址(最多5个地址)",
        addressWarning: "2.每个地址请分别用 / 符号隔开,最多指定5个地址,超出将默认取值前5个地址",
        addressWarning2: "1.请仔细确认地址填写正确，否则将导致订阅消息无法推送",
        notificationMethod: "通知方式",
        confirmSubmission: "确认提交",
        subscribedMetrics: "已订阅指标",
        subscriptionTime: "订阅时间",
        subscribedChannels: "订阅频道",
        subscriptionMetrics: "订阅指标",
        alarmThreshold: "告警阈值",
        alarmCycle: "告警周期",      
        unsubscribeReminder: "确认退订该项指标？",
        alarmAcknowledgement: "告警信息确认",
        Cancel: "取 消",
        Confirm: "确 定",
        address:"地址",
        numericalValue:"数值",
        ratio:"比值",
        day:"1天",
        realTimeData:"实时数据",
        addressVerification:"地址不能为空或输入中文字符!",
        noticeVerification:"请至少选择一种通知方式!",
        repeatSubscription:"该指标已订阅，不能重复订阅!",
        






    }
}
export const subscribe_en = {
    subscribe: {
        dayReport: "Quantity reported today",
        greatReport: "Number of major news reports",
        customizeMessage: "Customize the number of messages",
        unauditedReport: "Number of unaudited reports",
        reviewedReport: "Number of audited reports",
        chart: "Daily history chart",
        ReportRelease: "Report release",
        beReviewedRelease: "Report to be reviewed",
        number: "number",
        date: "date",
        ReportType: "Report type",
        state: "state",
        publisher: "publisher",
        auditor: "auditor",
        Subscriber: "Subscriber group",
        MessageTitle: "Message title",
        operation: "operation",
        audit: "audit",
        rejectedRelease: "Rejected report",
        correction: "correction",
        publishedRelease: "A report history has been published",
        details: "details",
        customizeHistory: "Customize the message history",
        subscriber1: "subscriber",
        subscriber1Email: "Subscribe to email",
        subscriber1Type: "Subscription type",
        subscribe2: "subscribe",
        DailySubscription: "Daily subscription",
        WeeklySubscription: "Weekly subscription",
        MajorSubscription: "Major news subscription",
        ConfirmSubscription: "Confirm subscription",
        SubscriptionHistory: "Subscription operation history",
        user: "user",
        OperationContent: "Operation content",
        MessageHistory: "Message history",
        receiveEmail: "Receiving mailbox",
        MessageDetails: "Message details",
        customizeSubscription: "Custom subscription",
        customizeIndex: "Customize subscription metrics",
        IndexName: "Index name",
        CurrentValue: "Current value",
        ConditionalSelection: "Condition selection (rise or fall or threshold)",
        increase: "Percentage increase",
        increaseValue: "Value of increase",
        decline: "Percentage decline",
        declineValue: "Decline value",
        SMA: "SMA selection",
        alarm: "Alarm cycle selection",
        unreadMessage: "Message details not read",
        time: "time",
        MessageContent: "Message content",
        Please: "Please enter",
        selectAlarm: "Select alarm indicators",
        subscriptionReport: "Subscription observation report",
        monthlyReport: "Monthly report subscription",
        Unsubscribed: "Unsubscribe",
        indicatorSelection: "selection",
        alarmType: "Alarm Type",       
        addressFilling: "Address",
        addressPrompt: "Specify addresses (up to 5 addresses)",
        addressWarning: "2.Please separate each address with a / symbol, and specify a maximum of 5 addresses. If exceeded, the default value will be the top 5 addresses",
        notificationMethod: "Notifications",
        confirmSubmission: "Confirm submission",
        subscribedMetrics: "Subscribed metrics",
        subscriptionTime: "Subscription time",
        subscribedChannels: "Subscribed Channels",
        subscriptionMetrics: "Subscription metrics",
        alarmThreshold: "Alarm threshold",
        alarmCycle: "Alarm cycle",       
        unsubscribeReminder: "Are you sure to unsubscribe from this indicator?",
        alarmAcknowledgement: "Alarm information confirmation",
        Cancel: "Cancel",
        Confirm: "Confirm",
        address:"address",
        numericalValue:"numerical Value",
        ratio:"ratio",
        day:"day",
        realTimeData:"RealTime",
        addressWarning2: "1.Please carefully confirm that the address is filled in correctly, otherwise it will result in subscription messages not being pushed",
        addressVerification:"The address cannot be empty or input Chinese characters!",
        noticeVerification:"Please select at least one notification method!",
        repeatSubscription:"This indicator is subscribed and cannot be subscribed again!",
        

      

    }



}

